import { useState } from 'react';
import { toast } from 'sonner';
import { api, errorText } from '../api';

function editableProduct(initial) {
  return { ...initial, tiers: initial.tiers.map(tier => ({ ...tier, editorId: crypto.randomUUID() })) };
}

function parseSpecifications(text) {
  return Object.fromEntries(text.split('\n').filter(line => line.includes(':')).map(line => {
    const separator = line.indexOf(':');
    return [line.slice(0, separator).trim(), line.slice(separator + 1).trim()];
  }));
}

export function useProductForm(initial, saved) {
  const [form, setForm] = useState(() => editableProduct(initial));
  const [files, setFiles] = useState(() => (initial.document_ids || []).map((id, index) => ({ id, name: `Technical document ${index + 1}` })));
  const [specText, setSpecText] = useState(() => Object.entries(initial.specs || {}).map(([key, value]) => `${key}: ${value}`).join('\n'));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const bind = key => ({ value: form[key], onChange: event => {
    const value = ['moq', 'stock', 'lead_days', 'gst_percent'].includes(key) ? Number(event.target.value) : event.target.value;
    setForm(current => ({ ...current, [key]: value }));
  } });
  const updateTier = (editorId, key, value) => setForm(current => ({ ...current,
    tiers: current.tiers.map(tier => tier.editorId === editorId ? { ...tier, [key]: value } : tier),
  }));

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const payload = { ...form, specs: parseSpecifications(specText), document_ids: files.map(file => file.id),
        tiers: form.tiers.map(({ min_qty, price }) => ({ min_qty, price })) };
      if (initial.id) await api.put(`/products/${initial.id}`, payload);
      else await api.post('/products', payload);
      toast.success(initial.id ? 'Listing updated' : 'Product published');
      saved();
    } catch (requestError) {
      setError(errorText(requestError));
    } finally { setBusy(false); }
  }
  return { form, bind, files, setFiles, specText, setSpecText, busy, error, updateTier, submit };
}